import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Alert, alertClasses, styled } from '@mui/material';

import { RouterButton } from '@components/base';
import { LayoutEntityType } from '@models/Content';

export type LayoutEntityConflictWarningProps = {
  entityType: LayoutEntityType;
};

const StyledAlert = styled(Alert)`
  display: flex;
  align-items: center;

  .${alertClasses.message} {
    align-items: center;
    display: flex;
    justify-content: space-between;
    width: 100%;
  }
`;

const LayoutEntityConflictWarning: FC<LayoutEntityConflictWarningProps> = ({ entityType }) => {
  const { t } = useTranslation();

  return (
    <StyledAlert
      action={
        <RouterButton color='inherit' rightIcon='openInNew' size='small' target='_blank' to='.'>
          {t('layoutEntityConflict.alert.button')}
        </RouterButton>
      }
      severity='warning'
    >
      {t('layoutEntityConflict.alert.message', {
        entityType: t(`contentType.${entityType}`).toLocaleLowerCase(),
      })}
    </StyledAlert>
  );
};

export default LayoutEntityConflictWarning;
